import React from 'react'
import './App.css'
import Home from './components/home/Home'
import About from './components/about/About'
import Project from './components/projects/Project'
import Contact from './components/contact/Contact'
import Footer from './components/footer/Footer'
import TopButton from './components/topButton/TopButton'

function App() {
  return (
    <div className="App">
      <Home />
      <About />
      <Project />
      <Contact />
      <Footer />
      <TopButton />
    </div>
  )
}

export default App
